import Vue from 'vue';
import { Swiper as SwiperClass, Mousewheel, Autoplay, Navigation, Controller, EffectFade, FreeMode } from 'swiper/swiper.esm'
import getAwesomeSwiper from 'vue-awesome-swiper/dist/exporter'
import 'swiper/swiper-bundle.min.css'

SwiperClass.use([Mousewheel, Autoplay, Navigation, Controller, EffectFade, FreeMode])
Vue.use(getAwesomeSwiper(SwiperClass))
// eslint-disable-next-line no-unused-vars
const { Swiper, SwiperSlide } = getAwesomeSwiper(SwiperClass)